export default __webpack_public_path__ + "static/anabel-b10deb0c27f2cec7af894b9d6755ec8f.png";